/* Observership external application: Activate your account page
 * Page will display success/fail message for activate result
 * User will receive confirmation email if activate is successful
 
 * author: @ch168189
 * created: 08/09/2023
 
 */
 
 import React, {useState,  useEffect} from "react";
 import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import {useLocation} from "react-router-dom"; 
 import webRootContext from "../components/webrootcontext/WebRootContext";


function ActivateAccount(props)  {

    
	const [activateSuccess, setActivateSuccess] = useState();  
	const location = useLocation();
	
	const successActivateMsgTitle =  <div>Thank you, your account has been activated. </div >
	const alreadyActivedMsgTitle = <div>Your account has already been activated. </div>
	const failedActiveMsgTitle =  <div>Sorry, there was a problem.</div>
	const successActiveMsgContent = <div>			   
				   <div className="padding-bottom-30">You may now <a href="./login">log in</a> and complete your application.</div>
						    						
							<div>
							 	<Button
						                text={"Log in"}
						                styleName={"button button--primary"}
						                id={"login"}
						                onClick={(e) => navPage(e)} 
						               />
						     </div>
	           </div>;
	  
	          
       const alreadyActivedMsgContent = <div>
				   <div className="padding-bottom-30">You may now <a href="./login">log in</a> and complete your application.</div>
						    						
							<div>
							 	<Button
						                text={"Log in"}
						                styleName={"button button--primary"}
						                id={"login"}
						                onClick={(e) => navPage(e)} />
						     </div>
	           </div>;
	           
	           
      const failedActiveMsgContent = <div>
	               <div className="padding-bottom-30">
				   The activation code did not match our records or has expired. Please <a className="color--boston-ocean" href="./RequestActivateToken" > activate your account</a> again.</div>
						    						
							<div className="padding-bottom-30">
							 	<Button
						                text={"ACTIVATE ACCOUNT"}
						                styleName={"button button--primary"}
						                id={"resendActivateCode"}
						                onClick={(e) => navPage(e)} />
						     </div>
						     
				     <div>Use the url below to activate your account if you’re unable to access the link/button above. <a className="color--boston-ocean" href="./RequestActivateToken">{"https://" + window.location.host + webRootContext + "/RequestActivateToken"}</a></div>
	           </div>;
	           
	 const failedAPIMsgContent = <div>
	               <div className="padding-bottom-30">
						   Sorry, there was a problem. Please try it again.
				   </div>
				   	    						
					<div>
					 	<Button
				                text={"ACTIVATE ACCOUNT"}
				                styleName={"button button--primary"}
				                id={"login"}
				                onClick={(e) => navPage(e)} />
				     </div>
	           </div>;
	
	const emailErrMsgContent =  <div>
					<div className="padding-bottom-30"> 
					    Your account has been activated.  But we are unable to send the activation successful confirmation email.
				     </div>
	           </div>; 
	                              
    const serverErrCode = -99;
	
    function navPage(event){
		
		
	   let id = event.target.id;
		switch (id){
			case "login": window.location.href =  webRootContext + "/Login"; break;
	
			case "resendActivateCode": 
			default: 
				window.location.href =  webRootContext + "/RequestActivateToken";  return;
		}
		
		
	}
	
	
	
	useEffect(() => {	
	    
	    const queryParameters = new URLSearchParams(location.search);
	    const verifyToken_api_url =  webRootContext + "/rest/usermanagement/activateAccount?" + queryParameters.toString() ;
	    
	    const userName = queryParameters.get("user");
	    const token = queryParameters.get("token");
	    
	    
	    if(token == null || token === "" || userName == null || userName === ""){
			setActivateSuccess(0);  //error 
			return;
		}
		
		fetch(verifyToken_api_url, {
			method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			mode: "cors"})
			.then((response) => {
				return response.json();
				
			})
			.then((data) => {
				setActivateSuccess(data);
			},(error) => {
				setActivateSuccess(serverErrCode);
			});		
	}, [ location.search,  serverErrCode])
	
	

return (
       <div className="div_3_col" >
       	
       
       		<div id="activated" className={((activateSuccess===1 || activateSuccess===2) ? 'show_div' : 'hide_div')}>
       		
				<div id="successDiv">
					<Ribbon label={"Activated"} status={"checkmark"} subheader={activateSuccess===1?successActivateMsgTitle:alreadyActivedMsgTitle} content={activateSuccess===1?successActiveMsgContent:alreadyActivedMsgContent} />
				</div>
			</div>
			
				
			<div id="activated2" className={(activateSuccess===-2 ? 'show_div' : 'hide_div')}>
				<div id="successDiv2">
					<Ribbon label={"Activated"} status={"checkmark"} subheader={successActivateMsgTitle} content={emailErrMsgContent} />
				</div>
			</div>
			   
			  <div id="activateFailed" className={(activateSuccess===0 ? 'show_div' : 'hide_div')}>
					<div id="failDiv">
						<Ribbon label={"Error"} status={"error"} subheader={failedActiveMsgTitle} content={failedActiveMsgContent} />
					</div>
			  </div>
			  
			  <div id="activateFailed2" className={(activateSuccess===serverErrCode ? 'show_div' : 'hide_div')}>
					<div id="failDiv2">
						<Ribbon label={"Error"} status={"error"} subheader={""} content={failedAPIMsgContent} />
					</div>
			  </div>
	   </div>
)

};
export default ActivateAccount;